import { useEffect } from 'react';

import { useHubspotTracking } from 'libs/hubspot/useHubspotTracking';
import { connectHubspot } from 'utils/hubspot';
import { IS_PRODUCTION_ENV } from 'constants/env.constants';

export default function HubspotTracking() {
  useEffect(() => {
    IS_PRODUCTION_ENV && connectHubspot();
  }, []);

  useHubspotTracking();

  return null;
}
